import type { TOC } from '@ember/component/template-only'
import { colspanMax } from 'teacher-ui-client/modifiers/colspan-max'
import FidgetSpinnerWaveComponent from '@blakeelearning/fidget/components/fidget/spinner/wave'

interface Signature {
  Element: HTMLTableCellElement
  Args: {
    show?: boolean
    /**
     * Set to true if the table has content rendered for the loader to appear on top of.
     */
    absolute?: boolean
  }
}

/**
 * A component to provide a table with a loading spinner.
 *
 * Since this makes use of position, make sure to apply `position: relative` to your tbody element.
 *
 * If placing inside a tbody with divide-y, make sure to place this row last to avoid it affecting row borders.
 */
export const RowLoading: TOC<Signature> = <template>
  {{#if @show}}
    {{#if @absolute}}
      {{! Take up entire size of tbody }}
      <tr class="absolute inset-0">
        <td class="absolute inset-0 bg-white/50"></td>
        <td class="absolute top-0 left-1/2 w-full -translate-x-1/2 transform text-center" {{colspanMax}} ...attributes>
          <FidgetSpinnerWaveComponent data-test-table-loading @small={{true}} @centered={{true}} />
        </td>
      </tr>
    {{else}}
      <tr>
        <td class="w-full text-center" {{colspanMax}} ...attributes>
          <FidgetSpinnerWaveComponent data-test-table-loading @small={{true}} @centered={{true}} />
        </td>
      </tr>
    {{/if}}
  {{/if}}
</template>
